<template>
  <div class="help-detail">
    <mt-header fixed :title="currentTitleText" class="title1">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div>
      <div class="detail-content">
        <div>
          <div class="title">
            <i class="mintui mintui-search"></i>&nbsp;
            <span>{{ currentHelpText.head }}</span>
          </div>
          <div class="content" v-html="currentHelpText.html"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_HELP_CXYF */

export default {
  name: 'HelpDetail',

  data() {
    return {
      helpText: PUBLIC_HELP_CXYF,
      upGradeImg: require('@/assets/upgrade_condition.png'),
    };
  },
  computed: {
    currentTitleText() {
      return this.helpText.filter(item => item.id === this.$route.query.id)[0].title;
    },
    currentHelpText() {
      const obj = this.helpText.filter(item => item.id === this.$route.query.id)[0];
      obj.id === '4' && (obj.html = obj.html.replace(/upGradeImg/g, this.upGradeImg));
      return obj;
    },
  },
};
</script>
